import { USDC_ADDRESSES, WETH_ADDRESSES } from '@/constants/addresses';
import { CHAIN_IDS } from '@/constants/chain';

import { fontStyles } from '@/styles/typography';

import { TokenAvatar } from '@/ui/Avatars/TokenAvatar';
import { ResponsiveBR } from '@/ui/ResponsiveBR';

import { StyledPrimaryCell, StyledH2, StyledParagraph, StyledSecondaryCell } from '../utils';

export const TransactionProcessingSection = () => (
  <StyledPrimaryCell className="rounded-t-[2.125rem] tablet:flex-row flex flex-col justify-between">
    <div className="tablet:mb-16 mb-18">
      <StyledH2>
        Move seamlessly <ResponsiveBR /> across chains
      </StyledH2>
      <StyledParagraph>
        Swap tokens between chains in one trade to
        <ResponsiveBR /> keep pace with fast-moving markets.
      </StyledParagraph>
    </div>
    <StyledSecondaryCell className="tablet:mx-0 relative mx-auto flex w-full max-w-97 flex-col items-center overflow-hidden bg-primitive-basic-white before:absolute before:-top-30 before:left-30 before:h-60 before:w-full before:rotate-[164deg] before:skew-[-2deg,-14deg] before:bg-[radial-gradient(50%_50%_at_50%_50%,#DBFF76_0%,rgba(78,225,54,0.00)_100%)] before:opacity-15 before:content-[''] after:absolute after:bottom-17.5 after:left-4 after:h-58 after:w-69.5 after:bg-[radial-gradient(50%_50%_at_50%_50%,#25BF75_0%,rgba(78,225,54,0.00)_100%)] after:opacity-15 after:content-['']">
      <div className="absolute z-10 h-17.5 w-full bg-gradient-to-b from-primitive-basic-white to-transparent opacity-70"></div>
      <div className="relative z-10 mt-11 flex">
        <div className="border-token-alphalight-300 after:bg-token-alphalight-300 tablet:mr-9.5 tablet:h-21.25 tablet:w-21.25 tablet:after:right-21.25 tablet:after:w-9.5 mr-7.5 flex h-17.25 w-17.25 items-center justify-center rounded-full border after:absolute after:right-17.25 after:h-px after:w-7.75 after:content-['']">
          <div className="border-token-alphalight-300 shadow-token-25 tablet:h-15.5 tablet:w-15.5 flex h-13 w-13 translate-z-0 transform items-center justify-center rounded-full border-[0.85px] bg-primitive-basic-white backface-hidden">
            <TokenAvatar address={USDC_ADDRESSES[CHAIN_IDS.MAINNET]} chainId={CHAIN_IDS.MAINNET} />
          </div>
        </div>
        <div className="border-token-alphalight-300 tablet:h-21.25 tablet:w-21.25 flex h-17.25 w-17.25 items-center justify-center rounded-full border">
          <div className="border-token-alphalight-300 shadow-token-25 tablet:h-15.5 tablet:w-15.5 flex h-13 w-13 translate-z-0 transform items-center justify-center rounded-full border-[0.85px] bg-primitive-basic-white backface-hidden">
            <TokenAvatar address={WETH_ADDRESSES[CHAIN_IDS.MATIC]} chainId={CHAIN_IDS.MATIC} />
          </div>
        </div>
      </div>
      <span
        className={fontStyles({
          variant: 'BODY_LG',
          class: 'text-token-gray-1600 z-1 mt-6 leading-8 font-semibold',
        })}
      >
        Transaction processing
      </span>
      <span
        className={fontStyles({
          variant: 'BODY_LG',
          className: 'text-token-gray-700 z-1 mb-3 leading-8 font-semibold',
        })}
      >
        Remaining time: 45s
      </span>
    </StyledSecondaryCell>
  </StyledPrimaryCell>
);
